export const KNOWN_CORONAVIRUS_TERMS = [
  "coronavirus",
  "corona virus",
  "wuhan virus",
  "wuhanvirus",
  "cronavirus",
  "cronovirus",
  "coronovirus",
  "new coronavirus",
  "novel coronavirus",
  "carona virus",
  "caronavirus",
  "conoravirus",
  "carronavirus",
  "carrona virus",
  "china virus",
  "chinavirus",
  "virus",
  "covid-19",
  "convid-19",
  "covid19",
  "convid19",
  "covid 19",
  "convid 19",
  "novel coronavirus (covid-19)",
]



// WEBPACK FOOTER //
// ./assets/integration/constants.js